import { useState } from "react";

import type { MeView } from "../api/types";
import { Banner } from "../ui/Banner";
import { Button } from "../ui/Button";

/** The key under which this browser remembers the reset the person has been told of (one notice for each reset). */
export const RESET_SEEN_KEY = "enex.resetNoticeSeen";

function seen(): string | null {
  try {
    return window.localStorage.getItem(RESET_SEEN_KEY);
  } catch {
    return null;
  }
}

function remember(at: string): void {
  try {
    window.localStorage.setItem(RESET_SEEN_KEY, at);
  } catch {
    // a browser that keeps nothing shows the notice again next time; nothing else depends on it
  }
}

function when(ts: string): string {
  const date = new Date(ts);
  if (Number.isNaN(date.getTime())) return ts;
  return date.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

/**
 * "The admin reset your password": told once after the sign-in that follows a reset by the admin (architecture 15.1). The
 * admin could sign in with a first password they chose; the person is told so they can raise it if they did not ask.
 */
export function ResetNotice({ me }: { me: MeView }) {
  const at = me.password_reset_noted_since ?? null;
  const [dismissed, setDismissed] = useState(() => (at ? seen() === at : true));
  if (!at || dismissed) return null;
  return (
    <Banner tone="warning">
      <p>
        The admin reset your password on {when(at)}. If you did not ask for it, tell your IT contact.{" "}
        <Button
          variant="quiet"
          onClick={() => {
            remember(at);
            setDismissed(true);
          }}
        >
          I have read this
        </Button>
      </p>
    </Banner>
  );
}
